export const cached = (f) => {
    let called = false;
    let r;
    return (...args) => {
        if (!called) {
            called = true;
            r = f.apply(null, args);
        }
        return r;
    };
};
//# sourceMappingURL=Thunk.js.map